// extracted by mini-css-extract-plugin
export default {"titleContainer":"TitleProducts_titleContainer__ZM2c9","icon":"TitleProducts_icon__74vEU","label":"TitleProducts_label__KoIl7","productTitle":"TitleProducts_productTitle__pe0KD"};